import styled from "styled-components"
import { Chart } from "primereact/chart"

const StyledBarGraph = styled(Chart)``

export default StyledBarGraph
